import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeImpersonationTokenApi } from "../api";

const ImpersonateLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const bootstrapClientSession = async () => {
      const token = searchParams.get("token");

      if (!token) {
        setError("Missing impersonation token.");
        return;
      }

      try {
        const res = await exchangeImpersonationTokenApi(token);
        localStorage.setItem("jwt_token", res.response.token);
        localStorage.setItem("details", JSON.stringify(res.response));
        navigate("/dashboard", { replace: true });
      } catch (err) {
        setError(err?.message || "Failed to login as client.");
      }
    };

    bootstrapClientSession();
  }, [navigate, searchParams]);

  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: "radial-gradient(ellipse at top left, #c3c6ff 10%, #9f9eea 70%, #1b1431 100%)",
        px: 2,
      }}
    >
      <Paper
        elevation={12}
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 420,
          borderRadius: 5,
          textAlign: "center",
          background: "rgba(255,255,255,0.14)",
          color: "#fff",
        }}
      >
        {error ? (
          <>
            <Typography variant="h6" fontWeight={700} mb={1}>
              Client login failed
            </Typography>
            <Typography>{error}</Typography>
          </>
        ) : (
          <>
            <CircularProgress sx={{ color: "#fff", mb: 2 }} />
            <Typography variant="h6" fontWeight={700} mb={1}>
              Signing in to client dashboard
            </Typography>
            <Typography>Please wait while your session is prepared.</Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default ImpersonateLogin;
